import i18n from "../../plugins/I18nPlugin";

export function endsWithCharacterRule(message = "rule.endsWithCharacterRule"): (value: any) => boolean | string {
  const regExp = RegExp(/[a-zA-Z]$/);
  return value => regExp.test(value) || String(i18n.tc(message));
}
